
import { computed, defineComponent, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
export default defineComponent({
  name: "vz-modal",
  emits: ["modal-confirm", "modal-reject", "modal-close"],
  props: {
    id: { type: String, default: "vz__modal__" },
    viewName: { type: String, default: "" },
    title: { type: String, default: "" },
    showClose: { type: Boolean, default: true },
    noActions: { type: Boolean, default: false },
    showDialog: { type: Boolean },
    cancelLabel: {
      type: String,
      default: () => TranslationService.translate("common.cancel"),
    },
    confirmLabel: {
      type: String,
      default: () => TranslationService.translate("common.save"),
    },
    maxWidth: {
      type: [String, Object, Array],
      default: "mw-650px",
      required: false,
    },
    widthClass: {
      type: [String, Object, Array],
      default: "width-500",
      required: false,
    },
    heightClass: {
      type: [String, Object, Array],
      default: "mh-510px",
      required: false,
    },
    modalClass: {
      type: [String, Object, Array],
      default: "",
    },
  },
  components: {},
  setup(props, { emit }) {
    const confirm = () => {
      emit("modal-confirm");
    };

    const showModalVal = toRef(props, "showDialog");
    let showModal = ref<any>(false);
    const close = () => {
      emit("modal-close");
    };
    const reject = () => {
      close();
      emit("modal-reject");
    };
    watch(showModalVal, (newVal) => {
      showModal.value = newVal;
    });
    return {
      confirm,
      close,
      reject,
      showModal,
    };
  },
});
